import React, { Component } from "react";
import { Button } from "react-bootstrap";
import Color from "../../assets/color";

// Component
import Icon from "../../components/Icon";
import MenuCardStyle from "./style";

class MenuOptionListInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionID: this.props.optionID,
      min: this.props.min,
      max: this.props.max
    };
  }

  handleChange = type => {
    const { value, selectedOptionIndex } = this.props;
    const { optionID, max } = this.state;

    let isReset = type === "minus" ? !!(value - 1 === 0) : false;
    let newValue = value;

    if (isReset) {
      this.props.onReset({ target: { checked: false, value: optionID } });
    } else {
      if (type === "add") {
        newValue++;
      } else if (type === "minus") {
        newValue--;
      }
    }

    this.props.onChange(optionID, newValue, max, selectedOptionIndex);
  };

  render() {
    const { value } = this.props;
    return (
      <MenuCardStyle>
        <div className="option-list d-flex align-items-center justify-content-center">
          <Button
            className="m-0 p-1 d-flex btn-qty btn-minus align-items-center justify-content-center"
            onClick={() => this.handleChange("minus")}
          >
            <Icon type="custom" name="minus" color={Color.primary} size={8} />
          </Button>
          <b className="mx-3">{value}</b>
          <Button
            className="m-0 p-1 d-flex btn-qty align-items-center justify-content-center"
            onClick={() => this.handleChange("add")}
          >
            <Icon type="custom" name="add" color={Color.primary} size={8} />
          </Button>
        </div>
      </MenuCardStyle>
    );
  }
}

export default MenuOptionListInput;
